import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as SurveyStore from '../../store/Survey';
import getLangTranslation, { LangKey } from '../../common/lang-trans';
import { RouteComponentProps } from 'react-router';
import logoen from '../../logo-en.svg';
import logofr from '../../logo-fr.svg';
import logo from '../../logo.svg';

type SurveyProps =
    SurveyStore.DataState
    & typeof SurveyStore.actionCreators
    & RouteComponentProps<{}>;

class SurveyHeader extends React.PureComponent<SurveyProps> {

    public render() {
        const language = this.props.language || 'en';
        const langTrans = getLangTranslation(language);
        const imgLogo = (this.props.step < 2 ? logo : (language === 'en' ? logoen : logofr))
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-9">
                        <img src={imgLogo} alt="logo" className="img-fluid ms-1 mb-2" style={{maxWidth: '15%', height: 'auto'}}></img>
                    </div>
                    <div className="col-sm-3">
                        <div className={`${this.props.step < 2 ? 'd-none' : 'd-flex flex-row-reverse'}`}>
                            <button className="btn btn-outline-primary" onClick={() => this.props.SetLanguage(langTrans.OtherLangShort, false)}>{langTrans.OtherLang}</button>
                        </div>
                    </div>
                </div>
                { this.renderHeaderLine(langTrans) }
            </React.Fragment>
        );
    }

    private renderHeaderLine(langTrans: LangKey){
        
        if (this.props.step < 2) {
            return (
            <div className="row">
                <div className="col">
                    <div className="progress" style={{height: '4px'}}>
                        <div className="progress-bar bg-success" role="progressbar" style={{width: '0%'}} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}></div>
                    </div>
                    <div className="progress" style={{height: '3px'}}>
                        <div className="progress-bar bg-warning" role="progressbar" style={{width: '100%'}} aria-valuenow={100} aria-valuemin={0} aria-valuemax={100}></div>
                    </div>
                </div>
            </div>);
        }

        return (
            <>
            <div className="row d-block d-sm-none">
                <div className="col">
                    <div className="progress">
                        <div className="progress-bar" role="progressbar"></div>
                        <div className="progress-bar bg-success" role="progressbar" style={{ width: ((this.props.step - 1) / 3 * 100) + '%' }}></div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col d-none d-sm-block">
                    <ul className="list-group list-group-horizontal" id="progress-menu">
                        <li className={`opo-list-group-item ${this.props.step > 2 ? 'visited completed' : ''} ${this.props.step === 2 ? 'active' : ''}`}>
                            <p>
                                <span title='header-title-hSODetails'>{langTrans.Start}</span>
                            </p>
                        </li>
                        <li className={`opo-list-group-item ${this.props.step > 3 ? 'visited completed' : ''} ${this.props.step === 3 ? 'active' : ''}`}>
                            <p>
                                <span title='header-title-hSODetails'>{langTrans.Questions}</span>
                            </p>
                        </li>
                        <li className={`opo-list-group-item ${this.props.step > 4 ? 'visited completed' : ''} ${this.props.step === 4 ? 'active' : ''}`}>
                            <p>
                                <span title='header-title-hSODetails'>{langTrans.Complete}</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            </>);
    }
};

export default connect(
    (state: ApplicationState) => state.surveyStore,
    SurveyStore.actionCreators
)(SurveyHeader as any);
